import { render, staticRenderFns } from "./Livecode.vue?vue&type=template&id=6dcf3e80&scoped=true&"
import script from "./Livecode.vue?vue&type=script&lang=js&"
export * from "./Livecode.vue?vue&type=script&lang=js&"
import style0 from "./Livecode.vue?vue&type=style&index=0&id=6dcf3e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf3e80",
  null
  
)

export default component.exports